<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-store-alt page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:680px;">
							<div class="row g-2">
								<div class="col">

								</div>
								<div class="col-auto" style="width:300px;">
									<div class="input-group">
										<input type="text" class="form-control" id="text-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch()" />
										<span class="input-group-text"><i class="fa fa-search"></i></span>
									</div>
								</div>
							</div>
						</div>

						<h2>Telephelyek</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Telephelyek</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'site',
						params: {
							columns: [
								{
									title: 'ID',
									field: 'id',
									type: 'number',
									width: 60
								}
							]
						},
						list: sites
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-edit me-3"></i>Megnyitás</button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		if (Anvil.page.search.machine_id) {
			Anvil.page.quickSearch()
		}
	},

	quickSearch () {
		const filters = []
		/*
		if (Anvil.page.search.machine_id) {
			filters.push(row => row.hardware_uuid == Anvil.page.search.machine_id)
		}
		*/

		const expression = $('#text-search').val()

		Anvil.models.components.Grid.find('#site_grid').filter(expression, filters)
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#site_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/site/modal_details', sel[0].id)
		}
	}
})

$('#error_log_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
